<template lang="pug" src="./custom-tab-section.pug"></template>

<script>
export default {
  props: ['props'],
  methods: {
    showContent (i) {
      this.$store.dispatch('VIEW_TYPES', i)
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-tab-section.vue?81432050